import { Injectable, Inject, forwardRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { IApiresponse } from "../../_models/common/request-response/apiresponse";
import { IApiRequest } from "../../_models/common/request-response/api-request";
import { setHeader } from "../../_helpers/setRequestHeader";
import { ClaimsHeaderService } from "../../shared/claimsHeader/claims-header.service";
import { IApplicationSettingListResponse } from "src/app/_models/application-setting/ApplicationSettingListResponse";

@Injectable({
  providedIn: "root",
})
export class ApplicationSettingService {
  httpHeaders: HttpHeaders;
  constructor(
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService,
     private header: setHeader,
  ) { }

  GetTrialDays() {
    let loginTokenHeader = this.header.authorizationHeader();
    return this.http.get<any>(
      `${environment.billingApiUrl}GetTrialDays`,
      {
        headers: loginTokenHeader,
      }
    );
  }
  GetApplicationSettingList() {
    return this.http.get<IApiresponse<IApplicationSettingListResponse[]>>(
      `${environment.billingApiUrl}GetAllApplicationSettings`,
      {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      }
    );
  }
}
